import React, { useEffect } from 'react';

// Lightweight Helmet/HelmetProvider shim used to avoid adding react-helmet-async
// (which has peer deps incompatible with React 19 in this project).

export const HelmetProvider = ({ children }) => {
  return <>{children}</>;
};

export const Helmet = ({ children }) => {
  useEffect(() => {
    const nodes = React.Children.toArray(children);

    nodes.forEach((node) => {
      if (!React.isValidElement(node)) return;
      const type = node.type;

      if (type === 'title') {
        const titleText = node.props.children;
        if (typeof titleText === 'string') document.title = titleText;
      }

      if (type === 'meta') {
        const { name, content, property } = node.props;
        const selector = property ? `meta[property="${property}"]` : `meta[name="${name}"]`;
        if (name || property) {
          let el = document.querySelector(selector);
          if (!el) {
            el = document.createElement('meta');
            if (property) el.setAttribute('property', property);
            if (name) el.setAttribute('name', name);
            document.head.appendChild(el);
          }
          if (content) el.setAttribute('content', content);
        }
      }

      if (type === 'link') {
        const { rel, href } = node.props;
        if (rel && href) {
          let el = document.querySelector(`link[rel="${rel}"]`);
          if (!el) {
            el = document.createElement('link');
            el.setAttribute('rel', rel);
            document.head.appendChild(el);
          }
          el.setAttribute('href', href);
        }
      }
    });
  }, [children]);

  return null;
};

export default Helmet;
